module.exports = __webpack_public_path__ + "img/RED_BERRIES.84b87cbf.png";